import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import store from "features/store";
import { MyAccountMenuList, ToggleSideBar, removeSideBar } from "features/components/base/auth-pages/MyAccount/MyAccountMenuList";
import { Button } from "react-bootstrap";
import './MemberService.scss'
import pmservice from "shared/services/pmservice";
import { isAuthorized, logout } from "shared/settings/auth";
import { addDataLayer } from "shared/utils/utils";
import { Helmet } from "react-helmet";
import moment from "moment";
import { Loader } from "shared/hoc/loader/Loader";

const MemberServicefn = (props) => {


  const [memberServiceData, setMemberServiceData] = useState('');
  const [pageloading, setPageLoading] = useState(true);
  const [creditData, setCreditData] = useState('');
  const [giftEntryVerifyStatus, setGiftEntryVerifyStatus] = useState('');

  useEffect(() => {
    if (isAuthorized()) {
      if (props.user.id) {
        getMemberService();
        getMemberCredits();
      } else {
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
        logout(props.history, false);
      }
    } else {
      store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }
  }, [props.user.id]);

  useEffect(() => {
    let dataLayerData = {
      'event': 'member_service',
      'buyr_id': props.user.id
    }
    addDataLayer(dataLayerData);
  }, []);

  const getMemberService = () => {
    pmservice.getContent('YourPremierBenefits', '').then((response) => {
      let memberServiceList = response.data.data[0].jsoncontent;
      memberServiceList = JSON.parse(memberServiceList);
      setMemberServiceData(memberServiceList);

      pmservice.getGiftEntryVerify().then((response) => {
        setGiftEntryVerifyStatus(response.data.data.optedIn)
        setPageLoading(false)
      }).catch(() => {
        setPageLoading(false)
      })


    })
      .catch((error) => {
        if (error?.status === 401) {
          store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
          logout(props.history, false);
        }
        setPageLoading(false)
      });
  }

  const navigateToScreen = (data) => {
    if (data.action.title == "Begin Return" || data.action.title == "File Delivery Claim") {
      window.open(data.action.navigatesToPage);
    }
    else if (data.action.title == "Enter To Win") {
      let data = [
        {
          "buyerid": props.user.id,
          "optedindate": moment().format('YYYY-MM-DD HH:mm:ss'),
        }
      ]

      pmservice.giftAdd(data).then((response) => {
        setGiftEntryVerifyStatus(true)
      })

    }
    else {
      props.history.push(data.action.navigatesToPage);
    }
  }

  const addEmailLink = (data) => {
    if (data.includes('#email#')) {
      const [contentData, emailData] = data.split('#email#');
      const [email, displayText] = emailData.split('#');
      return (
        <>
          {contentData}
          <a className="clickable" style={{ color: '#00263E', fontWeight: 'bold' }} href={`mailto:${email}`}>
            {displayText}
          </a>
        </>
      );
    }
    if (data.includes('#HREF')) {
      let splitdata = data.split('#HREF')
      return splitdata.map((data, index) => {
        if (index == 1) {
          let pdfData = data.split('#');
          return <a className="clickable" style={{ color: 'blue', textDecoration: 'underline' }} target="_blank" key={index} href={`${pdfData[1]}`}>{pdfData[2]}</a>
        }
        else {
          return data
        }
      })
    } else {
      return <span>{textchange(data)}</span>;
    }
  }

  const setTitle = (data) => {
    if (data.mysterystatus) {
      return giftEntryVerifyStatus ? data.action.title1 : data.action.title
    }
    else {
      return data.action.title
    }
  }

  const getMemberCredits = () => {
    const data = {
      "field": ["id", "buyerid", "creditsused", "creditsforyear", "creditsremaining"]
    };

    pmservice.getMembershipDetail(data).then((res) => {
      if (res.data.data.length > 0) {
        setCreditData(res.data.data[0]);
      }
    })
      .catch((error) => {
      });
  }

  const textchange = (data) => {
    let replaceContent = data;
    if (data.includes("CREDITPOINTSAVAILABLE")) {
      replaceContent = data.replace("CREDITPOINTSAVAILABLE", creditData['creditsforyear'])
      return replaceContent
    }
    return replaceContent;
  }

  return (
    <>
      <Helmet>
        <title>{`${props.history.location.pathname}` === '/my-account/premier/premier-membership' ? `CTBids | Premier Membership` : `CTBids | Member Benefits`}</title>
      </Helmet>
      {pageloading ?
        <Loader /> :
        <div className="w-100 memberserivce" style={{ padding: "30px", overflow: "auto" }}>
          <div className="d-flex align-items-center justify-content-center">
            <img className="w-80" src={memberServiceData?.logo} />
            <div className="font-weight-bold" style={{ marginLeft: "10px" }}>
              <h1 className="font-bold">{memberServiceData?.title}</h1>
            </div>
          </div>

          <div className="w-100 d-flex justify-content-between flex-wrap worthpoint-content mobile-resp">
            {memberServiceData?.body?.map((data, index) => (
              <div className="d-flex flex-column mt-5 mobile-wid align-items-center premier-member-details" key={index}>
                <img className="service-img" src={data.logo} alt={data.title} />
                <div className="font-bold fs-20 mt-2">{data.title}</div>
                <div className="mt-3" style={{ height: "70%" }}>{addEmailLink(data.description)}</div>
                <div className="d-flex w-100 justify-content-center">
                  {data.action && data.action.type === "button" ? (
                    <Button variant="secondary" className="service-btn" disabled={data.action.title1 && giftEntryVerifyStatus} onClick={() => { navigateToScreen(data) }}>
                      {setTitle(data)}
                    </Button>
                  ) : null}
                </div>
              </div>
            ))}

          </div>
          <div className="mt-5 w-100 d-flex align-items-center justify-content-center flex-column">
            <div className="fs-20 font-bold" style={{ color: '#00263E', fontSize: "24px" }}>
              {memberServiceData?.footer?.heading}
            </div>
            <div className="d-flex align-items-center mt-4 mobile-foot-resp">
              <div className="float-left" style={{ width: '20%' }}>
                <img className="w-100 clickable" onClick={() => window.open(memberServiceData?.footer?.navigatesTo)} src={memberServiceData?.footer?.logo} alt={memberServiceData?.footer?.title} />
              </div>
              <div className="float-right ml-50 w-100">
                <div className="font-bold fs-20" style={{ color: '#00263E', fontSize: "16px" }}>{memberServiceData?.footer?.title}</div>
                <div className="w-100 footer-resp mt-3" style={{ color: '#00263E' }}>{memberServiceData?.footer?.description}</div>
              </div>
            </div>
          </div>
        </div>}
    </>
  );
};

class MemberService extends React.Component {
  constructor(props) {
    super(props);
    this.buyrId = this.props.user.id;
  }

  componentDidMount() {
    store.dispatch({ type: "SIDEBAR_MENU_LIST", payload: { menuList: MyAccountMenuList(), withSpan: false } });
    ToggleSideBar();
    window.addEventListener("resize", ToggleSideBar);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", ToggleSideBar);
    removeSideBar();
  }

  render() {
    return <MemberServicefn {...this.props} />;
  }
}

export default connect((state) => state)(MemberService);
